(function () {
  console.log('inventory portal loaded');

  const API_BASE = 'https://shop-api.yashir-group.biz/api/inventory-portal';

  const authBox = document.getElementById('yg-ip-auth');
  const searchBox = document.getElementById('yg-ip-search');

  const phoneStep = document.getElementById('yg-ip-phone-step');
  const otpStep = document.getElementById('yg-ip-otp-step');

  const phoneInput = document.getElementById('yg-ip-phone');
  const otpInput = document.getElementById('yg-ip-otp');
  const queryInput = document.getElementById('yg-ip-query');
  const sendOtpBtn = document.getElementById('yg-ip-send-otp');
  const verifyOtpBtn = document.getElementById('yg-ip-verify-otp');
  const searchBtn = document.getElementById('yg-ip-search-btn');
  const logoutBtn = document.getElementById('yg-ip-logout');

  const authMsg = document.getElementById('yg-ip-auth-msg');
  const searchMsg = document.getElementById('yg-ip-search-msg');
  const results = document.getElementById('yg-ip-results');
  const userName = document.getElementById('yg-ip-user-name');


  let searchMode = 'free';

document.querySelectorAll('.yg-ip-mode-btn').forEach((btn) => {
  btn.addEventListener('click', function () {
    document.querySelectorAll('.yg-ip-mode-btn').forEach((b) => {
      b.classList.remove('active');
    });

    this.classList.add('active');
    searchMode = this.getAttribute('data-mode') || 'free';

   if (searchMode === 'sku') {

  document.getElementById('yg-ip-free-search').classList.remove('yg-ip-hidden');
  combinedFields.classList.add('yg-ip-hidden');

  queryInput.placeholder = 'הזן מק״ט או חלק ממק״ט';

} else if (searchMode === 'description') {

  document.getElementById('yg-ip-free-search').classList.remove('yg-ip-hidden');
  combinedFields.classList.add('yg-ip-hidden');

  queryInput.placeholder = 'הזן תיאור מוצר, לדוגמה: גוף תאורה PULSE';

} else if (searchMode === 'combined') {

  document.getElementById('yg-ip-free-search').classList.add('yg-ip-hidden');
  combinedFields.classList.remove('yg-ip-hidden');

} else {

 document.getElementById('yg-ip-free-search').classList.remove('yg-ip-hidden');
  combinedFields.classList.add('yg-ip-hidden');

  queryInput.placeholder = 'לדוגמה: מק״ט / כבל / תאורה / שקע';
}
  });
});

const combinedFields =
  document.getElementById('yg-ip-combined-fields');

const combinedSkuInput =
  document.getElementById('yg-ip-combined-sku');

const combinedDescInput =
  document.getElementById('yg-ip-combined-desc');


  if (!sendOtpBtn) {
    console.warn('Inventory portal elements not found');
    return;
  }


  function getSelectedBranches() {
  return Array.from(
    document.querySelectorAll(
      '.yg-ip-branches-filter input:checked'
    )
  ).map(cb => cb.value);
}

  function setMsg(el, text, type) {
    el.textContent = text || '';
    el.className = 'yg-ip-msg';

    if (type === 'error') el.classList.add('yg-ip-error');
    if (type === 'success') el.classList.add('yg-ip-success');
  }

  async function request(path, options = {}) {
    const res = await fetch(API_BASE + path, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {})
      },
      ...options
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw data;
    }

    return data;
  }

  async function checkStatus() {
    try {
      const data = await request('/auth/status');

      if (data.isAuthenticated) {
        showSearch(data.user);
      }
    } catch (e) {}
  }

  function showSearch(user) {
    authBox.classList.add('yg-ip-hidden');
    searchBox.classList.remove('yg-ip-hidden');

    userName.textContent = user?.name
      ? `שלום ${user.name}`
      : 'שלום';
  }

  sendOtpBtn.addEventListener('click', async function () {
    const phone = phoneInput.value.trim();

    if (!phone) {
      setMsg(authMsg, 'חובה להזין מספר טלפון', 'error');
      return;
    }

    sendOtpBtn.disabled = true;
    setMsg(authMsg, 'שולח קוד אימות...');

    try {
      const data = await request('/auth/phone', {
        method: 'POST',
        body: JSON.stringify({ phone })
      });

      phoneStep.classList.add('yg-ip-hidden');
      otpStep.classList.remove('yg-ip-hidden');
      otpInput.focus();

      setMsg(authMsg, data.message || 'נשלח קוד אימות', 'success');
    } catch (err) {
      setMsg(authMsg, err.message || 'אין לך הרשאה להשתמש במערכת', 'error');
    } finally {
      sendOtpBtn.disabled = false;
    }
  });

  verifyOtpBtn.addEventListener('click', async function () {
    const phone = phoneInput.value.trim();
    const otp = otpInput.value.trim();

    if (!otp) {
      setMsg(authMsg, 'חובה להזין קוד אימות', 'error');
      return;
    }

    verifyOtpBtn.disabled = true;
    setMsg(authMsg, 'מאמת קוד...');

    try {
      const data = await request('/auth/verify', {
        method: 'POST',
        body: JSON.stringify({ phone, otp })
      });

      showSearch(data.user);
    } catch (err) {
      setMsg(authMsg, err.message || 'קוד אימות שגוי', 'error');
    } finally {
      verifyOtpBtn.disabled = false;
    }
  });

  searchBtn.addEventListener('click', async function () {

  let url;

  if (searchMode === 'combined') {

    const sku = combinedSkuInput.value.trim();
    const description = combinedDescInput.value.trim();

    if (!sku && !description) {
      setMsg(
        searchMsg,
        'יש להזין מק״ט או תיאור מוצר',
        'error'
      );
      return;
    }

    url =
      '/search?mode=combined' +
      '&sku=' +
      encodeURIComponent(sku) +
      '&description=' +
      encodeURIComponent(description);

  } else {

    const q = queryInput.value.trim();

    if (!q) {
      setMsg(
        searchMsg,
        'חובה להזין ערך לחיפוש',
        'error'
      );
      return;
    }

    url =
      '/search?q=' +
      encodeURIComponent(q) +
      '&mode=' +
      encodeURIComponent(searchMode);
  }

  searchBtn.disabled = true;
  results.innerHTML = '';
  setMsg(searchMsg, 'מחפש מוצרים...');

  try {

    const data = await request(url, {
      method: 'GET'
    });

    renderSearchResults(data.data);
    setMsg(searchMsg, '', 'success');

  } catch (err) {

    setMsg(
      searchMsg,
      err.message || 'שגיאה בחיפוש מוצרים',
      'error'
    );

  } finally {

    searchBtn.disabled = false;

  }
});

  logoutBtn.addEventListener('click', async function () {
    try {
      await request('/auth/logout', {
        method: 'POST'
      });
    } catch (e) {}

    location.reload();
  });

  queryInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') searchBtn.click();
  });

  phoneInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') sendOtpBtn.click();
  });

  otpInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') verifyOtpBtn.click();
  });

  combinedSkuInput.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') searchBtn.click();
});

combinedDescInput.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') searchBtn.click();
});

  function renderResults(item) {
    if (!item) {
      results.innerHTML = '';
      return;
    }

    if (!item.found) {
      results.innerHTML = `
        <div class="yg-ip-product">
          <h3>לא נמצא מוצר</h3>
          <p>לא נמצא מוצר לפי החיפוש שהוזן.</p>
        </div>
      `;
      return;
    }

    const branchesHtml = (item.branches || []).map(function (branch) {
      return `
        <div class="yg-ip-branch ${branch.hasStock ? 'yes' : 'no'}">
          <div class="yg-ip-branch-name">${escapeHtml(branch.name)}</div>
          <div class="yg-ip-branch-status">
            ${branch.hasStock ? 'קיים במלאי' : 'אין מלאי'}
          </div>
          <div class="yg-ip-qty">
            ${branch.hasStock ? escapeHtml(String(branch.qty)) : '0'}
          </div>
        </div>
      `;
    }).join('');

    results.innerHTML = `
      <div class="yg-ip-product">
        <h3>${escapeHtml(item.product?.partdesc || item.sku || '')}</h3>
        <p>מק״ט: ${escapeHtml(item.product?.partname || item.sku || '')}</p>
      </div>

      <div class="yg-ip-branches">
        ${branchesHtml}
      </div>
    `;
  }

  function renderBranchesHtml(item) {
  if (!item || !item.found) {
    return `
      <div class="yg-ip-product yg-ip-out-of-stock">
        <h3>אין במלאי בשום סניף</h3>
        <p>הפריט נמצא במערכת, אבל אין לו מלאי זמין בסניפים שנבדקו.</p>
      </div>
    `;
  }

  const hasAnyStock = (item.branches || []).some((branch) => branch.hasStock);

  if (!hasAnyStock) {
    return `
      <div class="yg-ip-product yg-ip-out-of-stock">
        <h3>אין במלאי בשום סניף</h3>
        <p>הפריט נמצא, אבל הכמות היא 0 בכל הסניפים.</p>
      </div>

      <div class="yg-ip-branches">
        ${(item.branches || []).map((branch) => `
          <div class="yg-ip-branch no">
            <div class="yg-ip-branch-name">${escapeHtml(branch.name)}</div>
            <div class="yg-ip-branch-status">אין מלאי</div>
            <div class="yg-ip-qty">0</div>
          </div>
        `).join('')}
      </div>
    `;
  }

  return `
    <div class="yg-ip-branches">
      ${(item.branches || []).map((branch) => `
        <div class="yg-ip-branch ${branch.hasStock ? 'yes' : 'no'}">
          <div class="yg-ip-branch-name">${escapeHtml(branch.name)}</div>
          <div class="yg-ip-branch-status">
            ${branch.hasStock ? 'קיים במלאי' : 'אין מלאי'}
          </div>
          <div class="yg-ip-qty">
            ${branch.hasStock ? escapeHtml(String(branch.qty)) : '0'}
          </div>
        </div>
      `).join('')}
    </div>
  `;
}

  function renderSearchResults(data) {
  const rows = data?.rows || [];

  if (!rows.length) {
    results.innerHTML = `
      <div class="yg-ip-product">
        <h3>לא נמצאו מוצרים</h3>
        <p>נסה לחפש לפי מק״ט, חלק ממק״ט או מילה אחרת מהתיאור.</p>
      </div>
    `;
    return;
  }

  results.innerHTML = `
    <div class="yg-ip-product">
      <h3>נמצאו ${rows.length} תוצאות, על מנת לצמצם את התוצאות - יש לדייק יותר את החיפוש.</h3>
      <p>לחץ על מוצר כדי לראות מלאי בסניפים</p>
    </div>

    <div class="yg-ip-products-list">
     ${rows.map((item) => `
  <div class="yg-ip-result-item ${item.hasAnyStock === false ? 'yg-ip-result-no-stock' : ''}" data-sku="${escapeHtml(item.sku)}">
    <div>
      <strong>${escapeHtml(item.title)}</strong>
      <p>מק״ט: ${escapeHtml(item.sku)}</p>
      ${item.hasAnyStock === false ? '<span class="yg-ip-no-stock-badge">אין במלאי בשום סניף</span>' : ''}
    </div>
    <button type="button" class="yg-ip-small-btn">הצג מלאי</button>
    <div class="yg-ip-result-stock yg-ip-hidden"></div>
  </div>
`).join('')}
    </div>
  `;

  document.querySelectorAll('.yg-ip-result-item').forEach((el) => {
  el.addEventListener('click', async function () {
    document.querySelectorAll('.yg-ip-result-stock').forEach((box) => {
      if (box !== this.querySelector('.yg-ip-result-stock')) {
        box.classList.add('yg-ip-hidden');
        box.innerHTML = '';
      }
    });
      const sku = this.getAttribute('data-sku');
      const stockBox = this.querySelector('.yg-ip-result-stock');

      if (!sku || !stockBox) return;

      if (!stockBox.classList.contains('yg-ip-hidden')) {
        stockBox.classList.add('yg-ip-hidden');
        return;
      }

      stockBox.classList.remove('yg-ip-hidden');
      stockBox.innerHTML = '<div class="yg-ip-loading">טוען מלאי...</div>';

      try {
        let url = '/availability?sku=' + encodeURIComponent(sku);

        const branches = getSelectedBranches();

if (branches.length) {
  url += '&branches=' + encodeURIComponent(
    branches.join(',')
  );
}

        const data = await request(url, {
        method: 'GET'
        });

        stockBox.innerHTML = renderBranchesHtml(data.data);
      } catch (err) {
        stockBox.innerHTML = '<div class="yg-ip-error">שגיאה בטעינת מלאי</div>';
      }
    });
  });
}

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  checkStatus();
})();